import React from 'react';

// Material UI
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';

// Iconos
import IconButton from '@mui/material/IconButton';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';

import useStyles from './styles';
import useCart from '../../../../../hooks/orders/CartProvider';

const TitleSummary = () => {
    const { classes } = useStyles();
    const { update } = useCart();

    const handlerClearItems = () =>
        update({ items: [], perceptions: [], itemsToReturn: [] });

    return (
        <Card>
            <CardContent className={classes.root}>
                <Typography variant='h5' component='span'>
                    Resumen de la orden
                </Typography>
                <Tooltip title={<p style={{ fontSize: '14px' }}>Vaciar carrito</p>}>
                    <IconButton className={classes.buttonClear} size='small' onClick={handlerClearItems}>
                        <RemoveShoppingCartIcon fontSize='large' />
                    </IconButton>
                </Tooltip>
            </CardContent>
        </Card>
    )
}

export default TitleSummary;